import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-confirm-leave-modal',
  imports: [],
  template: `
    @if (show()) {
      <div class="fixed inset-0 z-[9999] flex items-center justify-center">
        <!-- Backdrop -->
        <div
          class="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity"
          (click)="onCancel()"
        ></div>
        <!-- Modal -->
        <div
          class="relative bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-md w-full mx-4 
                  transform transition-all animate-in fade-in zoom-in-95 duration-200"
        >
          <!-- Header avec icône warning -->
          <div class="flex flex-col items-center pt-6 pb-4 px-6">
            <div
              class="w-16 h-16 rounded-full bg-amber-100 dark:bg-amber-900/30 
                      flex items-center justify-center mb-4"
            >
              <svg
                class="w-8 h-8 text-amber-600 dark:text-amber-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
            <h3
              class="text-xl font-semibold text-gray-900 dark:text-white text-center"
            >
              Modifications non sauvegardées
            </h3>
            <p
              class="mt-2 text-sm text-gray-600 dark:text-gray-400 text-center"
            >
              Vous avez des modifications en cours. Si vous quittez maintenant,
              vos changements seront perdus.
            </p>
          </div>
          <!-- Actions -->
          <div class="flex flex-col-reverse sm:flex-row gap-3 p-6 pt-2">
            <button
              (click)="onCancel()"
              class="flex-1 px-4 py-3 text-sm font-medium text-gray-700 dark:text-gray-300 
                   bg-gray-100 dark:bg-slate-700 hover:bg-gray-200 dark:hover:bg-slate-600 dark:bg-slate-700 dark:hover:bg-slate-600
                   rounded-xl transition-colors focus:outline-none focus:ring-2 
                   focus:ring-offset-2 focus:ring-gray-300 dark:ring-slate-600"
            >
              Rester sur la page
            </button>
            <button
              (click)="onConfirm()"
              class="flex-1 px-4 py-3 text-sm font-medium text-white 
                   bg-red-600 hover:bg-red-700 
                   rounded-xl transition-colors focus:outline-none focus:ring-2 
                   focus:ring-offset-2 focus:ring-red-500"
            >
              Quitter sans sauvegarder
            </button>
          </div>
        </div>
      </div>
    }
  `,
  styles: [
    `
      @keyframes fade-in {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }

      @keyframes zoom-in-95 {
        from {
          transform: scale(0.95);
          opacity: 0;
        }
        to {
          transform: scale(1);
          opacity: 1;
        }
      }

      .animate-in {
        animation:
          fade-in 0.2s ease-out,
          zoom-in-95 0.2s ease-out;
      }
    `,
  ],
})
export class ConfirmLeaveModalComponent {
  readonly show = input<boolean>(false);
  readonly confirm = output<void>();
  readonly cancel = output<void>();

  onConfirm() {
    this.confirm.emit();
  }

  onCancel() {
    this.cancel.emit();
  }
}
